import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Detail from "./Detail.js"
import Delete from "./Delete.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Personal extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "pk",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Apellido",
                    id: "apellido",
                    accessor: d => d.apellido,
                    show: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Teléfono",
                    id: "telefono",
                    accessor: d => d.telefono,
                    show: true,
                },
                {
                    Header: "Email",
                    id: "email",
                    accessor: d => d.email,
                    show: true,
                },
                {
                    Header: "Es Usuario",
                    id: "isuser",
                    accessor: d => d.isuser,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        component: Create,
                        permission: 'personal_add',
                    },
                    {
                        edit:true,
                        component: Edit,
                        permission: 'personal_edit',
                    },
                    {
                        detail: true,
                        component: Detail,
                        permission: 'personal_detail',
                    },
                    {
                        edit:true,
                        component: Delete,
                        permission: 'personal_delete',
                    }
                ]}
                apiUrl={api.usuarios.personal.list}
                columns={this.state.columns}
                exportUrl={api.usuarios.personal.export}
                title={"Personal"}
            />
        );
    }
}

export default Personal;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Personal/Personal.js